import Carousel from "./Carousel";
import Spoiler from "./Spoiler";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import moment from "moment";
import Viewer from "viewerjs";
import smoothscroll from "smoothscroll-polyfill";
import { ResizeObserver as ResizeObserverPolyfill } from "@juggle/resize-observer";
import Swiper from "swiper";
import "lazysizes";
import ClipboardJS from "clipboard";

const GOB = {
    GIWebViewInitiated: false,

    initLiveStream() {
        let liveStreamToggleEl = document.getElementById("now-live-toggle");
        if (!liveStreamToggleEl) {
            return;
        }
        let liveStreamEl = document.getElementById("now-live");
        if (!liveStreamEl) {
            return;
        }
        const toggleStream = function () {
            let liveStreamEl = document.getElementById("now-live");
            if (
                liveStreamEl.classList.contains("now-live-type-event") &&
                !liveStreamEl.classList.contains("now-live-live")
            ) {
                return;
            }
            if (liveStreamEl.classList.contains("embed-open")) {
                liveStreamEl.classList.remove("embed-open");
                let iframe = liveStreamEl.querySelector("iframe");
                iframe.parentNode.removeChild(iframe);
            } else {
                liveStreamEl.classList.add("embed-open");
                let embed = document.getElementById("now-live-embed");
                let iframe = document.createElement("IFRAME");
                iframe.src = embed.dataset.url;
                iframe.classList.add("embed-responsive-item");
                iframe.setAttribute("frameborder", "0");
                iframe.setAttribute("allowfullscreen", "true");
                iframe.setAttribute("scrolling", "no");
                embed.querySelector(".embed-responsive").appendChild(iframe);
            }
        };
        liveStreamToggleEl.addEventListener("click", toggleStream);
        if (liveStreamEl.classList.contains("now-live-type-event")) {
            let timer = liveStreamEl.querySelector(".now-live-timer");
            if (!timer) {
                return;
            }
            let startValue = Number(timer.dataset.start * 1000);
            if (startValue) {
                let eventStart = moment(startValue);
                let startNode = liveStreamEl.querySelector(
                    ".now-live-date-text"
                );
                if (startNode) {
                    startNode.innerHTML = eventStart
                        .format("D MMM, HH:mm")
                        .toUpperCase();
                }
            }
            let timerValue = Number(timer.dataset.timer);
            if (!timerValue) {
                return;
            }
            this.initLiveStreamTimer(timerValue);
        }
    },

    initLiveStreamTimer(seconds) {
        this.liveStreamTimerSeconds = seconds;
        this.updateLiveStreamTimer();
    },

    updateLiveStreamTimer() {
        let seconds = this.liveStreamTimerSeconds;
        let days = Math.floor(seconds / 24 / 60 / 60);
        let hoursLeft = Math.floor(seconds - days * 86400);
        let hours = Math.floor(hoursLeft / 3600);
        let minutesLeft = Math.floor(hoursLeft - hours * 3600);
        let minutes = Math.floor(minutesLeft / 60);
        let secondsLeft = Math.floor(minutesLeft - minutes * 60);

        function pad(n) {
            return n < 10 ? "0" + n : n;
        }

        if (seconds <= 60 * 20) {
            document.getElementById("now-live").classList.add("now-live-live");
        }
        let el = document.querySelector(".now-live-timer");
        if (seconds === 0) {
            el.innerHTML = "WATCH NOW";
            document.querySelector(".now-live-date").innerHTML =
                '<div class="now-live-date-title">LIVE NOW</div>';
        } else {
            hours = pad(hours);
            minutes = pad(minutes);
            secondsLeft = pad(secondsLeft);
            el.innerHTML =
                "<div><strong>" +
                hours +
                ":" +
                minutes +
                ":" +
                secondsLeft +
                "</strong></div>";
            this.liveStreamTimerSeconds--;
            setTimeout(this.updateLiveStreamTimer.bind(this), 1000);
        }
    },

    initNavbar() {
        let navbarOpen = document.getElementById("navbar-open");
        let navbarClose = document.getElementById("navbar-close");
        let navbarOverlay = document.getElementById("navbarNavOverlay");
        if (!navbarOpen || !navbarClose) {
            return;
        }
        const openNavbar = function () {
            let navbar = document.getElementById("navbar-main");

            if (!navbar) {
                return;
            }

            navbar.classList.add("navbar-expanded");

            let collapse = navbar.querySelector(".navbar-collapse-toggle");
            let toggleMenuEl = document.getElementById("navbar-open");

            if (collapse) {
                collapse.style.height = toggleMenuEl.offsetHeight + "px";
            }

            document.body.classList.add("navbar-open");
            disableBodyScroll(navbar.querySelector(".navbar-collapse"));
        };
        const closeNavbar = function () {
            let navbar = document.getElementById("navbar-main");
            if (!navbar) {
                return;
            }
            navbar.classList.remove("navbar-expanded");
            document.body.classList.remove("navbar-open");
            enableBodyScroll(navbar.querySelector(".navbar-collapse"));
        };
        navbarOpen.addEventListener("click", openNavbar.bind(this));
        navbarClose.addEventListener("click", closeNavbar.bind(this));
        navbarOverlay.addEventListener("click", closeNavbar.bind(this));

        function hasTouch() {
            return (
                "ontouchstart" in document.documentElement ||
                navigator.maxTouchPoints > 0 ||
                navigator.msMaxTouchPoints > 0
            );
        }

        let scheduleNav = document.getElementById("schedule-nav");

        if (scheduleNav) {
            $("body").scrollspy({
                target: ".schedule-spy-active",
                offset: 5,
                method: "auto"
            });

            if (!hasTouch()) {
                document.body.className += " hasHover";
            }

            document
                .querySelectorAll('.schedule-navigation a.nav-link[href^="#"]')
                .forEach(anchor => {
                    anchor.addEventListener("click", function (e) {
                        e.preventDefault();

                        let $scheduleNav = $("#schedule-nav .navbar-nav");

                        $scheduleNav.removeClass("schedule-spy-active");

                        // Unfortunately can't use scrollIntoView here because it does not have a callback and we need it for
                        // disabling/activating scrollspy when page is scrolling to element
                        $("html, body").animate(
                            {
                                scrollTop: $($.attr(this, "href")).offset().top
                            },
                            function () {
                                $scheduleNav.addClass("schedule-spy-active");
                            }
                        );

                        // Forcefully have the clicked item menu .active, ignoring what scrollspy had set active
                        if ($(e.target).hasClass("nav-link")) {
                            var target = $(e.target);

                            $(target)
                                .parents(".navbar-nav")
                                .find(".active")
                                .removeClass("active");
                            $(target).addClass("active");
                        }
                    });
                });

            document
                .querySelectorAll('.schedule-tags a[href^="#"]')
                .forEach(anchor => {
                    anchor.addEventListener("click", function (e) {
                        e.preventDefault();

                        $("html, body").animate({
                            scrollTop: $($.attr(this, "href")).offset().top - 35
                        });
                    });
                });
        }
    },

    archiveScrollBottom() {
        jQuery(() => {
            $("#navbar-open").click(() => {
                setTimeout(function () {
                    $("#archiveDropdownToggle").click();
                    $("#navbarNav").animate({
                        scrollTop: $("#navbarNav")[0].scrollHeight
                    });
                }, 500);
            });
        });
    },

    fixHover() {
        var el = this;
        var par = el.parentNode;
        var next = el.nextSibling;
        par.removeChild(el);
        setTimeout(function () {
            par.insertBefore(el, next);
        }, 0);
    },

    setupButtons() {
        let backBtns = document.querySelectorAll(".gi-webview-back-btn"),
            i;

        for (i = 0; i < backBtns.length; ++i) {
            backBtns[i].addEventListener("click", e => {
                let params = new URL(document.location).searchParams;
                let firstpageParam = params.get("firstpage");
                if (firstpageParam === "true") {
                    // Global variables that will be injected by mobile app
                    try {
                        GIWebViewJS.Close();
                    } catch (e) {
                        console.warn(e);
                    }
                    event.preventDefault();
                } else if (window.history.length > 1) {
                    window.history.go(-1);
                    event.preventDefault();
                }
                /* find a way to save external referrer and use it
                else if (document.referrer) {
                    window.location = document.referrer;
                    event.preventDefault();
                }
                */
                return false;
            });
        }

        let exitBtns = document.querySelectorAll(".gi-webview-exit-btn"),
            j;

        for (j = 0; j < exitBtns.length; ++j) {
            exitBtns[j].addEventListener("click", e => {
                let params = new URL(document.location).searchParams;
                let closeBtnParam = params.get("closeAsBack") || params.get('SimpleView');

                if (closeBtnParam === "true") {
                    window.history.back();
                } else {
                    // Global variables that will be injected by mobile app
                    try {
                        GIWebViewJS.Close();
                    } catch (e) {
                        console.warn(e);
                    }
                }

                return false;
            });
        }
    },

    initGIWebView() {
        if (this.GIWebViewInitiated === true) {
            return;
        }
        this.GIWebViewInitiated = true;
        document.body.classList.add("gi-webview");

        //Setup buttons after load
        document.addEventListener("DOMContentLoaded", this.setupButtons());

        // To prevent some mysterious page scrolling on iOS Safari when clicking the logo, even though the scrolling
        // happens anyway if you click on other elements
        let scrollFix = document.querySelector(".navbar-brand");
        if (scrollFix) {
            scrollFix.addEventListener("touchend", event => {
                event.preventDefault();
            });
        }

        // Preserve webview URL param
        // TODO: Remove this when X-GI-Webview header checking is deployed in production
        let anchors = document.querySelectorAll(
            "a[href]:not([data-webview-ignore])"
        );

        anchors.forEach(el => {
            var url = new URL(el.href);

            if (url.hash) {
                return false;
            }

            if (url.host !== window.location.host) {
                return false;
            }

            url.searchParams.set("webview", "true");
            el.href = url.toString();
        });
    },

    initViewHeight() {
        var h = $(window).outerHeight();
        let vh = h * 0.01;
        document.documentElement.style.setProperty("--vh", `${vh}px`);

        //Resize event and timer
        var oTimer;
        window.matchMedia("(orientation: portrait)").onchange = function () {
            clearTimeout(oTimer);
            oTimer = setTimeout(function () {
                var h = $(window).outerHeight();
                let vh = h * 0.01;
                document.documentElement.style.setProperty("--vh", `${vh}px`);
            }, 250);
        };

        window.onresize = function () {
            clearTimeout(oTimer);
            oTimer = setTimeout(function () {
                var h = $(window).outerHeight();
                let vh = h * 0.01;
                document.documentElement.style.setProperty("--vh", `${vh}px`);
            }, 250);
        };
    },

    initSpoilers() {
        let spoilers = document.querySelectorAll(".spoiler");
        spoilers.forEach(spoiler => {
            // Because of the nature of unexpected news markup, we wrap this in try..catch to avoid breaking site
            try {
                new Spoiler(spoiler);
            } catch (err) {
                console.error(err);
            }
        });
    },

    init() {
        // Setup vh variable
        this.initViewHeight();

        let carouselEl = document.getElementById("news-carousel");
        if (carouselEl) {
            new Carousel(carouselEl);
        }

        new Swiper(".swiper-init", {
            slidesPerView: 'auto',
            initialSlide: 1,
            centeredSlides: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            }
        });

        let corpWarsChoice = document.getElementById("corp-wars-choice");
        if (corpWarsChoice) {
            new Swiper(corpWarsChoice, {
                resistanceRatio: 0,
                initialSlide: 1,
                navigation: {
                    nextEl: ".pandora-back-btn",
                    prevEl: ".goliath-back-btn"
                }
            });

            let vertical = document.querySelectorAll('.swiper-vertical');
            vertical.forEach(function (item) {
                new Swiper(item, {
                    resistanceRatio: 0,
                    direction: 'vertical',
                    navigation: {
                        nextEl: ".vertical-button-next",
                    }
                });
            });
        }

        let downloadsCarouselEl = document.getElementById("download-carousel");
        if (downloadsCarouselEl) {
            new Swiper(".swiper-container", {
                loop: true,
                speed: 500,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },
                navigation: {
                    nextEl: ".download-swiper-button-next",
                    prevEl: ".download-swiper-button-prev"
                }
            });
        }
        let fullscreenReader = document.getElementById("reader-fullscreen");
        if (fullscreenReader) {
            new Swiper(".swiper-container", {
                speed: 1000,
                zoom: {
                    maxRatio: 1.5
                },
                pagination: {
                    el: ".swiper-pagination"
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            });
        }
        let article = document.querySelector(".open-article .article");
        if (article) {
            new Viewer(article, {
                navbar: false,
                title: false,
                movable: false,
                rotatable: false,
                tooltip: false,
                zoomable: false,
                toolbar: {
                    prev: {
                        show: 4,
                        size: "large"
                    },
                    next: {
                        show: 4,
                        size: "large"
                    }
                },
                /**
                 * @param image Element
                 */
                filter(image) {
                    return !(
                        image.parentNode.tagName === "A" &&
                        image.parentNode.getAttribute("href") !== null
                    );
                },
                /**
                 * @param image Element
                 */
                url(image) {
                    return (
                        image.getAttribute("data-src-high-res") ||
                        image.getAttribute("src")
                    );
                },
                inheritedAttributes() {
                    return [
                        "crossOrigin",
                        "decoding",
                        "isMap",
                        "loading",
                        "referrerPolicy",
                        "sizes",
                        "useMap"
                    ];
                }
            });
            this.setupTableOverflowScrollForArticles();
            this.setupCopyToClipboardForArticles();
        }

        this.initLiveStream();
        this.initNavbar();
        this.initSpoilers();
        this.setupNavigation();
        this.setupScrollToTop();
        this.parseScheduleDates();
    },

    toggleEvent(node) {
        if (window.innerWidth >= 992 && this.GIWebViewInitiated === false) {
            return;
        }

        if (node.classList.contains("event-open")) {
            node.classList.remove("event-open");
            return;
        }

        let openEvents = document.querySelectorAll(
            ".events-list .event-thumbnail.event-open"
        );

        Array.prototype.forEach.call(openEvents, function (element) {
            element.classList.remove("event-open");
        });

        // Enable higher resolution image in <picture>
        let toggleableImgSources = node.querySelectorAll(
            "source.toggleable-source"
        );

        Array.prototype.forEach.call(toggleableImgSources, function (
            toggleableSource
        ) {
            toggleableSource.setAttribute(
                "srcset",
                toggleableSource.getAttribute("data-toggle-srcset")
            );
            toggleableSource.removeAttribute("data-toggle-srcset");
            toggleableSource.classList.remove("toggleable-source");
        });

        node.classList.add("event-open");

        let navHeight = document.getElementById("navbar-main").offsetHeight;

        $("html, body").animate(
            {
                scrollTop: $(node).offset().top - navHeight - 28
            },
            300
        );
    },

    toggleFeaturedEvent() {
        let featuredEventNode = document.querySelector(
            ".event-thumbnail.is-featured"
        );

        if (!featuredEventNode) {
            return;
        }

        if (window.innerWidth < 576) {
            return;
        }

        if (window.innerWidth > 992 && this.GIWebViewInitiated === false) {
            return;
        }

        this.toggleEvent(featuredEventNode);
    },

    parseScheduleDates() {
        const elements = document.querySelectorAll(
            ".event-thumbnail .js-date, .featured-event .js-date"
        );

        if (elements.length) {
            for (let element of elements) {
                if (!element.dataset.datetime || !element.dataset.format) {
                    continue;
                }
                if (element.dataset.locale) {
                    moment.locale(element.dataset.locale);
                }
                element.innerText = moment
                    .utc(element.dataset.datetime)
                    .local()
                    .format(element.dataset.format)
                    .toUpperCase();
            }
        }
    },

    showVideo(element) {
        let setModalWidth = function () {
            let width = 800;
            let height = 800 * 0.5625;
            if (height > window.innerHeight - 112) {
                height = window.innerHeight - 112;
                width = height / 0.5625;
            }
            document.querySelector(
                "#video-modal .modal-dialog"
            ).style.maxWidth = width + "px";
        };

        let videoSrc = "https://www.youtube.com/embed/";
        videoSrc += element.dataset.videoid + "?autoplay=1&enablejsapi=1";
        let videoFrame = document.getElementById("video-iframe");
        videoFrame.setAttribute("allowFullScreen", "true");
        videoFrame.src = videoSrc;
        setModalWidth();
        let modal = $("#video-modal");
        modal.modal("show");
        modal.on("hide.bs.modal", function (e) {
            videoFrame.src = "";
            modal.off("hide.bs.modal");
        });

        //Resize event and timer
        var oTimer;
        window.matchMedia("(orientation: portrait)").onchange = function () {
            clearTimeout(oTimer);
            oTimer = setTimeout(function () {
                setModalWidth();
            }, 250);
        };
    },

    setupScrollToTop() {
        let scrollToTop = document.getElementById("scrollToTop");
        if (!scrollToTop) {
            return;
        }

        function adjustScrollToTopEl() {
            var pageOffset =
                document.documentElement.scrollTop || document.body.scrollTop;

            if (pageOffset > 100) {
                $("#scrollToTop").fadeIn(100);
            } else {
                $("#scrollToTop").fadeOut(100);
            }
        }

        adjustScrollToTopEl();

        var scrollTimer;

        $(window).scroll(function () {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
                adjustScrollToTopEl();
            }, 150);
        });

        smoothscroll.polyfill();

        document
            .getElementById("scrollToTop")
            .addEventListener("click", function (e) {
                $("#scrollToTop").hide();
                window.scrollTo({ top: 0, behavior: "smooth" });
            });
    },

    setupNavigation() {
        let navigation = document.getElementById("navbar-main");
        if (!navigation) {
            return;
        }

        const ResizeObserver = window.ResizeObserver || ResizeObserverPolyfill;
        // this.calculateNavigation();
        document.addEventListener("DOMContentLoaded", () => {
            this.calculateNavigation();
            const navigationObserver = new ResizeObserver(entries => {
                this.calculateNavigation();
            });
            let items = document.getElementById("main-navigation-items");
            let button = document.getElementById("main-navigation-button");

            navigationObserver.observe(items);
            navigationObserver.observe(button);
        });
    },

    calculateNavigation() {
        let items = document.getElementById("main-navigation-items")
            .offsetWidth;
        let button = document.getElementById("main-navigation-button")
            .offsetWidth;
        document.getElementById("sub-navigation-items").style.minWidth =
            items + button + "px";
    },

    setupTableOverflowScrollForArticles() {
        let openArticle = document.getElementsByClassName("open-article");

        if (openArticle.length) {
            let tables = openArticle[0].getElementsByTagName("table");

            Array.from(tables).forEach(function (table) {
                // element that will be wrapped
                let el = table;

                // create wrapper container
                let wrapper = document.createElement("div");
                wrapper.classList.add("table-overflow-x-wrapper");

                // insert wrapper before el in the DOM tree
                el.parentNode.insertBefore(wrapper, el);

                // move el into wrapper
                wrapper.appendChild(el);
            });
        }
    },

    setupCopyToClipboardForArticles() {
        let clipboard = new ClipboardJS(".article .copy-to-clipboard", {
            text: function (trigger) {
                return trigger.getAttribute("href");
            }
        });

        $('.article .copy-to-clipboard[data-toggle="tooltip"]').tooltip({
            placement: "right",
            text: "Link copied!",
            trigger: "manual"
        });

        let clearTooltip;

        clipboard.on("success", function (e) {
            clearTimeout(clearTooltip);

            let btn = $('.article .copy-to-clipboard[data-toggle="tooltip"]');
            btn.tooltip("show");

            clearTooltip = setTimeout(function () {
                btn.tooltip("hide");
            }, 1500);
        });
    }
};

export default GOB;
